<template>
  <button
    type="button"
    class="theme-button button"
    :class="{
      button__active: isActive,
      button__disabled: disabled,
      button__compact: compact,
      button__rounded: rounded,
      button__secondary: color === 'secondary',
      button__primary: color === 'primary',
      button__gray: color === 'gray',
      button__black: color === 'black',
      'button__color-filled': colorFilled,
    }"
    @click="$emit('click', $event)"
    :id="id"
    :disabled="disabled"
  >
    <slot></slot>
  </button>
</template>

<script setup>
defineProps({
  isActive: { type: Boolean, default: false },
  id: { type: String, default: '' },
  disabled: { type: Boolean, default: false },
  compact: { type: Boolean, default: false },
  rounded: { type: Boolean, default: false },
  color: { type: String, default: 'tertiary' },
  colorFilled: { type: Boolean, default: false },
})
defineEmits(['click'])
</script>

<style lang="scss" scoped>
.theme-button {
  padding: $spacing-3 $spacing-5;
  border: 1px solid $brand-tertiary;
  border-radius: $spacing-1;
  font-size: $text-base;
  font-weight: $font-semibold;
  color: $brand-tertiary;
  -webkit-appearance: none !important;

  &:hover {
    color: $brand-tertiary;
    opacity: unset;
  }

  &.button__active {
    color: $white;
    background-color: $brand-tertiary;

    &:hover {
      color: $white;
    }

    &:focus {
      outline: unset;
      box-shadow: unset;
    }

    &.button__secondary {
      background-color: $brand-secondary;
      border: unset;
    }
  }

  &.button__disabled {
    color: $gray;
    border-color: $gray;
  }

  &.button__gray:not(.button__active) {
    color: $gray;
    border-color: $gray-lighter;
  }

  &.button__black:not(.button__active) {
    color: black;
    border-color: $gray-lighter;
  }

  &.button__color-filled:not(.button__disabled) {
    background-color: $brand-tertiary;
    border-color: $brand-tertiary;
    color: $white;
  }

  &.button__color-filled.button__gray,
  &.button__color-filled.button__disabled {
    background-color: $gray-lighter;
    border-color: $gray-lighter;
  }

  &.button__color-filled.button__primary:not(.button__disabled) {
    background-color: $brand-primary;
    border-color: $brand-primary;
    color: $white;
  }

  &.button__color-filled.button__secondary,
  &.button__color-filled.button__secondary.button__disabled {
    color: $white;
    background-color: $brand-secondary;
    border: unset;
  }

  &.button__compact {
    width: min-content;
  }

  &.button__rounded {
    border-radius: $rounded-max;
  }
}
</style>
